import EmpDownloadHudHost from "../components/empDownloadHud/EmpDownloadHudHost.vue";
import { empDownloadHudOpen, empDownloadHudClose } from "../_helpers/empDownloadHud.store";

/**
 * 全局下載 / 導出進度 Toast（右下角）。
 *
 * main.js: import empDownloadHudPlugin from './plugins/empDownloadHud.plugin'; Vue.use(empDownloadHudPlugin);
 * App.vue: <EmpDownloadHudHost />（與 router-view 同級掛一次）
 *
 * 任意組件：
 *   this.$empDownloadHud.show({
 *     title: this.$t('...'),
 *     subtitle: this.$t('...'),
 *     contextLabel: '可選，右側省略號',
 *     variant: 'progress' or 'error',
 *     autoCloseMs: optional; auto-hide after this many ms (e.g. op-log timeout toast 10000),
 *   });
 *   this.$empDownloadHud.hide();
 */
export default {
  install(Vue) {
    Vue.component(EmpDownloadHudHost.name || "EmpDownloadHudHost", EmpDownloadHudHost);
    Vue.prototype.$empDownloadHud = {
      show(opts) {
        empDownloadHudOpen(opts || {});
      },
      hide() {
        empDownloadHudClose();
      },
    };
  },
};
